import StatusBadge from 'components/badges/StatusBadge';

import useTranslation from './hooks/useTranslation';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const GoodStatusBadge: FunctionComponent<Props> = ({ className = '', testId = TEST_ID, text }) => {
    const { GOOD } = useTranslation();

    return (
        <StatusBadge
            className={`${className} ${styles.goodStatusBadge}`}
            testId={testId}
            text={text ?? GOOD}
        />
    );
};

export default GoodStatusBadge;
